/*
This is a experiment for Taylor Wimpy
*/
const branchIdsSet = new Set([
    '147208',
    '147211',
    '147215',
    '147218',
    '147221',
    '147222',
    '147223',
    '147225',
    '147226',
    '147230',
    '147231',
    '147234',
    '147237',
    '147239',
    '147240',
    '147241',
    '147245',
    '147248',
    '147254',
    '147257',
    '147259',
    '147261',
    '147263',
    '147264',
    '147266',
    '147267',
    '147268',
    '147270',
    '147271',
    '147272',
    '147273',
    '147274',
    '147275',
    '147276',
    '147277',
    '147278',
    '147279',
    '147280',
    '147281',
    '147282',
    '147283',
    '147285',
    '147286',
    '147287',
    '147288',
    '147289',
    '147291',
    '147293',
    '147294',
    '147296',
    '147298',
    '147300',
    '147302',
    '147305',
    '147307',
    '147308',
    '147309',
    '147310',
    '147733',
    '147314',
    '147315',
    '147318',
    '147320',
    '147322',
    '147324',
    '147327',
    '147236',
    '147328',
    '147330',
    '147333',
    '147334',
    '147336',
    '147337',
    '147340',
    '147342',
    '147343',
    '147354',
    '147347',
    '147350',
    '147356',
    '147358',
    '147360',
    '147361',
    '147364',
    '147366',
    '147367',
    '147368',
    '147369',
    '147372',
    '147375',
    '147377',
    '147381',
    '147388',
    '147389',
    '147391',
    '147393',
    '147394',
    '147395',
    '147397',
    '147399',
    '147401',
    '147405',
    '147406',
    '147408',
    '147411',
    '147416',
    '147419',
    '147421',
    '147422',
    '147423',
    '147425',
    '147427',
    '147432',
    '147434',
    '147435',
    '147436',
    '147325',
    '147438',
    '147439',
    '147442',
    '147443',
    '147444',
    '147445',
    '147446',
    '147447',
    '147448',
    '147451',
    '147453',
    '147454',
    '147455',
    '147456',
    '148051',
    '147458',
    '147460',
    '147459',
    '147462',
    '147464',
    '147467',
    '147468',
    '147471',
    '147472',
    '148066',
    '147474',
    '147475',
    '147477',
    '147480',
    '147483',
    '147488',
    '147490',
    '147492',
    '147495',
    '147499',
    '147501',
    '147505',
    '147508',
    '147511',
    '147725',
    '147513',
    '147517',
    '147518',
    '147519',
    '147520',
    '147522',
    '147524',
    '147525',
    '147526',
    '147528',
    '147530',
    '147531',
    '147532',
    '147533',
    '147534',
    '147536',
    '147537',
    '147540',
    '147541',
    '147542',
    '147719',
    '147543',
    '147545',
    '147712',
    '147546',
    '147549',
    '147551',
    '147554',
    '147556',
    '147557',
    '147558',
    '147560',
    '147561',
    '147562',
    '147565',
    '147567',
    '147568',
    '147570',
    '147571',
    '147573',
    '147575',
    '147576',
    '147577',
    '147581',
    '147582',
    '147706',
    '147585',
    '147700',
    '147587',
    '147589',
    '147590',
    '147591',
    '147592',
    '147593',
    '147594',
    '147595',
    '147596',
    '147598',
    '147600',
    '147601',
    '147602',
    '147604',
    '147607',
    '147610',
    '147611',
    '147613',
    '147614',
    '147616',
    '147617',
    '147619',
    '147621',
    '147623',
    '147624',
    '147625',
    '147627',
    '147629',
    '147632'
]);

export const isBranchTaylorWimpey = (branchId: string | number) => {
    return branchIdsSet.has(String(branchId));
};
